var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"product"},[_c('div',{staticClass:"hero-wrapper"},[_c('base-heading',{attrs:{"tag":"h1","heading":"header","subheading":"subheader"}})],1),_c('cms-multi-section',{attrs:{"value":"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }